import { createSlice } from "@reduxjs/toolkit";
import {
  getExtraTopicThunk,
  createExtraTopicThunk,
  updateExtraTopicThunk,
  deleteExtraTopicThunk,
} from "./ExtraTopic.Thunk";

const initialState = {
  data: [],
  topic: [],
  loading: false,
  status: "",
  message: "",
  type: "",
  language: "",
  topicid: "",
  topicname: "",
  usertype: "",
  disable_content_button: true,
};

const ExtraTopicSlice = createSlice({
  name: "extratopicslice",
  initialState,
  reducers: {
    language_change: (state, action) => {
      state.language = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.topicid = "";
      state.topicname = "";
      state.disable_content_button = true;
    },
  },
  extraReducers: {
    [getExtraTopicThunk.pending]: (state, action) => {
      state.topic = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getExtraTopicThunk.fulfilled]: (state, action) => {
      state.topic = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getExtraTopicThunk.rejected]: (state, action) => {
      state.topic = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [createExtraTopicThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createExtraTopicThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createExtraTopicThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [updateExtraTopicThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateExtraTopicThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateExtraTopicThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const {language_change, usertype_change } = ExtraTopicSlice.actions;

export default ExtraTopicSlice.reducer;
